import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { Image } from "react-native-expo-image-cache";
import colors from "../config/colors";

function CardHistory({ 
                title, 
                imageUrl, 
                onPress, 
                thumbnailUrl,
                }) {
  return (
      <View style={styles.card}>
        <TouchableOpacity onPress={onPress} styles={styles.image}>
          <Image
            onPress={onPress}
            style={styles.image}
            tint="light"
            preview={{ uri: thumbnailUrl }}
            uri={imageUrl}
            resizeMode="center"              
          />
        </TouchableOpacity>
      </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    backgroundColor: colors.white,
    marginBottom: 20,
    overflow: "hidden",
  },
  image: {
    width: 100,
    height: 200,
  },
});

export default CardHistory;
